import { styled } from '@linaria/react';
import { bodyFont, fonts, primitives, radius, semantic, size, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-600']};
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${space['space-200']};
`;

export const RangeLabel = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.base};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  color: ${semantic.text.primary};
`;

export const NavControls = styled.div`
  display: flex;
  align-items: center;
  gap: ${space['space-0']};
`;

export const NavButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${primitives.size['size-1000']};
  padding: ${space['space-100']} ${space['space-400']};
  border: none;
  background: transparent;
  cursor: pointer;
  color: ${semantic.text.primary};
  box-sizing: border-box;
  border-radius: ${radius('button', 'radius-full')};
  transition: background 0.15s ease;

  &:hover {
    background: ${semantic.bg.surfaceSubtle};
  }

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  row-gap: ${space['space-300']};
  justify-items: center;
`;

export const WeekdayCell = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.medium};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  text-align: center;
  color: ${semantic.text.secondary};
`;

export const DayCell = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: ${size.radius['radius-full']};
  background: transparent;
  cursor: pointer;
  font-family: ${bodyFont};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.medium};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  color: ${semantic.text.primary};
  padding: 0;
  transition: background 0.15s ease, color 0.15s ease;

  &:disabled {
    color: ${semantic.text.disabled};
    cursor: not-allowed;
  }

  &:hover:not(:disabled):not([data-selected]) {
    background: ${semantic.bg.surfaceSubtle};
  }

  &[data-selected] {
    background: ${semantic.bg.brand};
    color: ${semantic.text.inverse};
  }
`;
